import appConfig from "@appConfig";

export const SEGMENTS_TO_REPORT = appConfig.segmentsForAnalytics
  ? appConfig.segmentsForAnalytics.split(",")
  : [];
